import { QuoteCardProps } from '@diversioteam/diversio-ds'
import { loadInspirationalQuotes } from 'sagas/network'

import { featureFlagger } from '../featureFlagger'
import fixtureData from '../fixtures/quoteCard.data.json'
import { Queries } from 'api/queries.enum'

import { useQuery } from './useQuery'

type InspirationalQuotes = Omit<QuoteCardProps, 'onReload'>[]

export const useInspirationalQuotes = () => {
    const isHomeMocked = featureFlagger.getFeatureValue('mocked-home', false)

    const query = useQuery<InspirationalQuotes, Error>({
        queryKey: [Queries.getInsipirationalQuotes],
        queryFn: loadInspirationalQuotes,
    })

    return !isHomeMocked
        ? query
        : {
              isLoading: false,
              data: fixtureData,
          }
}
